module.exports = __webpack_public_path__ + "assets/img/1.32a81b9c.png";